import { render, staticRenderFns } from "./BillAddRefund.vue?vue&type=template&id=2b1a2c65&scoped=true"
import script from "./BillAddRefund.vue?vue&type=script&lang=js"
export * from "./BillAddRefund.vue?vue&type=script&lang=js"
import style0 from "./BillAddRefund.vue?vue&type=style&index=0&id=2b1a2c65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a2c65",
  null
  
)

export default component.exports